import { jsx as d } from "react/jsx-runtime";
import { u as c } from "./index-6a632112.mjs";
import { c as u, s as t, a, e as n, d as l } from "./themes-5f0b3c3d.mjs";
import { l as o } from "./lineHeights-72d3110c.mjs";
import "react";
const m = c.div`
  --avatar-background-color: ${({ type: e }) => {
  switch (e) {
    case "primary":
      return u.brandBlue[1e3];
    case "accent":
      return u.accentBlue[1e3];
    default:
      return u.brandBlue[1e3];
  }
}};

  --avatar-height: ${({ size: e, $initials: r }) => {
  switch (!0) {
    case (e === "large" && r !== void 0):
      return t["12x"];
    case (e === "medium" && r !== void 0):
      return t["10x"];
    case (e === "small" && r !== void 0):
      return t["8x"];
    case (e === "extraSmall" && r !== void 0):
      return t["6x"];
    default:
      return t["10x"];
  }
}};
  --avatar-width: ${({ size: e, $initials: r }) => {
  switch (!0) {
    case (e === "large" && r !== void 0):
      return t["12x"];
    case (e === "medium" && r !== void 0):
      return t["10x"];
    case (e === "small" && r !== void 0):
      return t["8x"];
    case (e === "extraSmall" && r !== void 0):
      return t["6x"];
    default:
      return t["10x"];
  }
}};

  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: var(--avatar-height);
  width: var(--avatar-width);
  border-radius: 50%;
  text-align: center;
  background-color: var(--avatar-background-color);
`, s = c.span`
  --font-size: ${({ size: e, $initials: r }) => {
  switch (!0) {
    case (e === "large" && r !== void 0):
      return a.medium;
    case (e === "medium" && r !== void 0):
      return a.small;
    case (e === "small" && r !== void 0):
      return a.xsmall;
    case (e === "extraSmall" && r !== void 0):
      return a.xxsmall;
    default:
      return a.small;
  }
}};
  --line-height: ${({ size: e, $initials: r }) => {
  switch (!0) {
    case (e === "large" && r !== void 0):
      return o.large;
    case (e === "medium" && r !== void 0):
      return o.medium;
    case (e === "small" && r !== void 0):
      return o.small;
    case (e === "extraSmall" && r !== void 0):
      return o.xsmall;
    default:
      return o.xsmall;
  }
}};

  --font-weight: ${({ size: e, $initials: r }) => {
  switch (!0) {
    case (e === "extraSmall" && r !== void 0):
      return n.semiBold.XS.fontWeight;
    case (e === "small" && r !== void 0):
      return n.medium.S.fontWeight;
    case (e === "medium" && r !== void 0):
      return n.medium.M.fontWeight;
    case (e === "large" && r !== void 0):
    default:
      return n.medium.L.fontWeight;
  }
}};
  display: inline-flex;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size);
  line-height: var(--line-height);
  color: #ffffff;
  font-family: ${l.body};
  text-align: center;
  font-style: ${l.body};
  font-weight: var(--font-weight);
`;
function x({ initials: e, ...r }) {
  return /* @__PURE__ */ d(m, { $initials: e, ...r, children: /* @__PURE__ */ d(
    s,
    {
      $initials: e,
      "data-testid": "avatar-content",
      ...r,
      children: e
    }
  ) });
}
export {
  x as AvatarNew
};
